<template>
    <div>
        <table class="table table-bordered table-striped mt-4">
            <thead>
            <tr>
                <th>ID</th>
                <th>Created At</th>
                <th>Updated At</th>
                <th>Amount</th>
                <th>Payment system ID</th>
                <th>Status</th>
                <th>Refund Amount</th>
                <th>Captured</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="payment in payments" :key="payment.id">
                <td>{{ payment.id }}</td>
                <td>{{ formatedDate(payment.created_at) }}</td>
                <td>{{ formatedDate(payment.updated_at) }}</td>
                <td>{{ payment.amount + ' ' + payment.currency }}</td>
                <td><a target="_blank" :href="'https://dashboard.stripe.com/payments/' + payment.payment_system_id">{{ payment.payment_system_id }}</a></td>
                <td>{{ payment.status }}</td>
                <td>{{ payment.is_refund ? (payment.refund_amount ? ('partial refund $' + payment.refund_amount) : 'fully refund') : '' }}</td>
                <td>{{ payment.is_capture ? '+' : '-' }}</td>
            </tr>
            </tbody>
        </table>
        <b-pagination
            v-if="paginator.total / paginator.perPage > 1"
            :value="page"
            :total-rows="paginator.total"
            :per-page="paginator.perPage"
            @change="change($event)"
        ></b-pagination>
    </div>
</template>

<script>
export default {
    name: "Payments",
    props: {
        'page': {
            'default': 1
        },
        'clientId': {}
    },
    data() {
        return {
            payments: [],
            paginator: []
        }
    },
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.getPayments(event);
        },
        getPayments(page) {
            window.axios.get('/admin/wallet/client/' + this.clientId + '/payments', {params: {page: page}})
                .then(response => {
                        this.payments = response.data.payments;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
    },
    mounted() {
        this.getPayments(this.page);
    }
}
</script>